<div fxLayout="column" class="form-content-row" [formGroup]="formGroup">
  <div style="display: flex; flex-direction: row">
    <!-- Billable Org -->
    <app-dropdown-form-field
      formControlName="billableOrg"
      fieldLabel="{{ 'MoveForms.General.DestinationBillableOrg' }}"
      [formGroup]="formGroup"
      [placeholder]="'MoveForms.General.SelectBillableOrganiation'"
      [options]="billableOrgList"
      localizeOptions="false"
      (selectionChange)="onBillableOrgValueChanged($event)"
    >
    </app-dropdown-form-field>

    <!-- Enable Edit -->
    <app-form-field
      fieldLabel="{{ 'MoveForms.General.EnableEdit' }}"
      fieldControlName="isEditEnabled"
      type="checkbox"
      [formGroup]="formGroup"
      [labelPosition]="'before'"
      [formState]="false"
      col="2"
      #editEnabledRef
      (valueChanged)="onEnableEditValueChanged($event)"
      appAuthorization
      [policy]="securityPolicies.RequireSuperUser"
      [policyOptions]="{
        componentRef: editEnabledRef,
        policyAction: 'Disable'
      }"
    ></app-form-field>
  </div>

  <!-- Organization -->
  <app-dropdown-form-field
    formControlName="org"
    fieldLabel="{{ 'MoveForms.General.DestinationOrganization' }}"
    [formGroup]="formGroup"
    [placeholder]="'MoveForms.General.SelectOrganization'"
    [options]="orgList"
    localizeOptions="false"
    (selectionChange)="onOrgValueChanged($event)"
  >
  </app-dropdown-form-field>

  <!-- location -->
  <app-dropdown-form-field
    formControlName="location"
    fieldLabel="{{ 'MoveForms.General.Location' }}"
    [formGroup]="formGroup"
    [placeholder]="'MoveForms.General.SelectLocation'"
    localizeOptions="false"
    [options]="locationList"
    (selectionChange)="onLocationValueChanged($event)"
    [enableVirtualization]="false"
  >
  </app-dropdown-form-field>
</div>
